import axios from 'axios'
import { Message, MessageBox, Loading } from 'element-ui'
import auth from "@/utils/auth"
import Utils from "@/utils/util"


// 创建axios实例
const service = axios.create({
  withCredentials: true,
  baseURL: process.env.BASE_API, // api 的 base_url
  // baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 5000 // 请求超时时间
})
let loading;
let timer;

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    let token = auth.getToken() || "";
    if( config.token == undefined) {
      config.headers['token'] = token;
    }
    if(config.member && !token){
      return Promise.reject(new Error('member'))
    }
      // config.headers['usertype'] = auth.getUserType();
    // }
    // loading = Loading.service({
    //   background: "rgba(0,0,0,0.5)"
    // });
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // setTimeout(() => {
    //   loading.close();
    // }, 500)

    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;

    if (res.code != 200) {
      // 非法的token 当用户的token信息不正确时所返回的状态  可结合自己业务进行修改
      if (res.code == 403 || res.code == 416) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          MessageBox.confirm(
            '您的登录信息已过期，可以取消继续留在该页面，或者重新登录', '登录失败', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              auth.loginOut(() => {
                // location.reload()
                return Utils.$emit('login');
              });
            })
        }, 1000)
        return Promise.reject('error');
      }
      Message({
        message: res.datas.error,
        type: 'error',
        duration: 4000
      })
      return Promise.reject('error')
    } else {
      return response.data.datas
    }
  },
  error => {
    // setTimeout(() => {
    //   loading.close();
    // }, 500)
    if(error.message == 'member') return false;
    Message({
      message: "服务器繁忙，请稍后重试",
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js